import React from 'react';
import { HeroSectionContent } from './HeroSectionContent';
import {
  MobileWrapperBox,
  MobileTopCloudImage,
  MobileCloudImage,
  MobileWaveTagCloudImage,
  MobilePicCloudImage,
  MobileArtCloudImage,
} from './HeroSection.styles';

export const HeroSectionMobile: React.FC = () => {
  return (
    <MobileWrapperBox paddingTop={14} paddingBottom={'14rem'}>
      <MobileTopCloudImage
        isEagerLoading={true}
        mobileResizeWidth={850}
        src="careers/mobile/top-art-v2.png"
        width="100%"
        height="100%"
        optimization="aggressive"
      />
      <HeroSectionContent id="careersMobile" />
      <MobileCloudImage isEagerLoading={true} src="careers/mobile/bottom-art-v2.png" width="100%" height="100%" optimization="aggressive" />
      <MobileWaveTagCloudImage src="careers/mobile/wave-tag.svg" width="40" height="100%" optimization="aggressive" />
      <MobilePicCloudImage src="careers/mobile/pic1.jpg" height="100%" optimization="aggressive" />
      <MobileArtCloudImage src="careers/mobile/art.jpg" optimization="aggressive" />
    </MobileWrapperBox>
  );
};
